// import React, { useState } from "react";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import BtnLoader from "Components/Common/Loader/BtnLoader";
// import axios from "axios";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: 500,
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: 8,
//   boxShadow: 24,
//   p: 4,
// };

// const WithdrawalApprovedPopup = ({
//   approvedPopupOpen,
//   handleCloseApproved,
//   warningMsg,
//   withdrawalItem,
// }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     requestedAmount: withdrawalItem?.requestedAmount || "",
//     status: "Approved",
//     tds: "",
//     disbursedAmount: 0,
//     // paymentMethod: withdrawalItem?.paymentMethod || "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     const data = JSON.stringify({
//       requestedAmount: formData.requestedAmount,
//       status: formData.status,
//       tds: formData.tds,
//       disbursedAmount: formData.disbursedAmount,
//       //   paymentMethod: formData.paymentMethod,
//     });

//     const config = {
//       method: "put",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/manual-withdrawal/update/${withdrawalItem?._id}`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data,
//     };

//     try {
//       const response = await axios.request(config);
//       console.log("API Response:", response.data);
//       // Optionally show a success message or perform further actions
//       setIsLoading(false);
//       handleCloseApproved(); // Close the modal on success
//     } catch (error) {
//       console.error("API Error:", error);
//       // Optionally show an error message
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Modal
//       open={approvedPopupOpen}
//       onClose={handleCloseApproved}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box sx={style}>
//         <div className="w-full">
//           <div className="mb-4 flex items-center">
//             <img
//               src={withdrawalItem?.userId?.selected_Avatar}
//               alt="Avatar"
//               className="mr-2 h-14 w-14 rounded-full"
//             />
//             <h2 className="text-xl font-semibold tracking-wide">
//               {withdrawalItem?.userId?.fullName}
//             </h2>
//           </div>
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div className="space-y-4">
//               <div className="flex space-x-4">
//                 <div className="flex-1">
//                   <label
//                     htmlFor="requestedAmount"
//                     className="mb-2 block text-lg tracking-wide"
//                   >
//                     Requested Amount
//                   </label>
//                   <input
//                     type="text"
//                     id="requestedAmount"
//                     name="requestedAmount"
//                     value={withdrawalItem?.requestedAmount}
//                     // onChange={handleChange}
//                     disabled
//                     className="w-full rounded-md border p-2"
//                     required
//                   />
//                 </div>
//                 <div className="flex-1">
//                   <label
//                     htmlFor="status"
//                     className="mb-2 block text-lg tracking-wide"
//                   >
//                     Status
//                   </label>
//                   <input
//                     type="text"
//                     id="status"
//                     name="status"
//                     value={"Approved"}
//                     // onChange={handleChange}
//                     disabled
//                     className="w-full rounded-md border p-2 font-mono tracking-wide text-green-500"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="flex space-x-4">
//                 <div className="flex-1">
//                   <label
//                     htmlFor="tds"
//                     className="mb-2 block text-lg tracking-wide"
//                   >
//                     TDS (in %)
//                   </label>
//                   <input
//                     type="number"
//                     id="tds"
//                     name="tds"
//                     value={formData.tds}
//                     onChange={(e) => {
//                       handleChange(e);
//                       setFormData({
//                         ...formData,
//                         disbursedAmount:
//                           formData.requestedAmount -
//                           formData.requestedAmount * (e.target.value / 100),
//                       });
//                     }}
//                     className="w-full rounded-md border p-2"
//                     required
//                   />
//                 </div>
//                 <div className="flex-1">
//                   <label
//                     htmlFor="processedAmount"
//                     className="mb-2 block text-lg tracking-wide"
//                   >
//                     Processed Amount
//                   </label>
//                   <input
//                     type="text"
//                     id="disbursedAmount"
//                     name="disbursedAmount"
//                     value={formData.disbursedAmount.toFixed(2)}
//                     // onChange={handleChange}
//                     className="w-full rounded-md border p-2"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="flex space-x-4">
//                 <div className="flex-1">
//                   <label
//                     htmlFor="paymentMethod"
//                     className="mb-2 block text-lg tracking-wide"
//                   >
//                     Transaction ID (UTR)
//                   </label>
//                   <input
//                     type="text"
//                     id="transactionId"
//                     name="transactionId"
//                     value={formData.transactionId}
//                     onChange={handleChange}
//                     className="w-full rounded-md border p-2"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="flex justify-end space-x-4 tracking-wide">
//                 <button
//                   className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
//                   onClick={handleCloseApproved}
//                 >
//                   Cancel
//                 </button>
//                 {isLoading ? (
//                   <button
//                     className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white"
//                     disabled
//                   >
//                     <BtnLoader />
//                   </button>
//                 ) : (
//                   <button
//                     type="submit"
//                     className="rounded-md bg-[#c51369] p-3 font-medium text-white transition duration-200 hover:bg-[#a10f5b]"
//                   >
//                     {warningMsg}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </form>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default WithdrawalApprovedPopup;

import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const WithdrawalApprovedPopup = ({
  approvedPopupOpen,
  handleCloseApproved,
  warningMsg,
  withdrawalItem,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    requestedAmount: withdrawalItem?.requestedAmount,
    status: "Approved",
    tds: "",
    disbursedAmount: 0,
    transactionId: "",
  });

  useEffect(() => {
    setFormData({
      requestedAmount: withdrawalItem?.requestedAmount,
      status: "Approved",
      tds: "",
      disbursedAmount: 0,
      transactionId: "",
    });
  }, [withdrawalItem]);

  // console.log("Withdrawal Item=======>", withdrawalItem);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTdsChange = (e) => {
    const tdsValue = parseFloat(e.target.value) || 0;
    const requested = parseFloat(withdrawalItem?.requestedAmount) || 0;
    const disbursed = requested - (requested * tdsValue) / 100;

    setFormData((prev) => ({
      ...prev,
      tds: tdsValue,
      disbursedAmount: disbursed,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const data = JSON.stringify({
      requestedAmount: withdrawalItem?.requestedAmount,
      status: formData.status,
      tds: formData.tds,
      disbursedAmount: formData.disbursedAmount,
      transactionId: formData.transactionId,
    });

    console.log("Data to be submitted ==>", data);

    const config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/manual-withdrawal/update-status/${withdrawalItem?._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    try {
      const response = await axios.request(config);
      console.log("API Response:", response.data);
      setIsLoading(false);

      handleCloseApproved();
      setFormData({
        requestedAmount: "",
        status: "",
        tds: 0,
        disbursedAmount: 0,
        transactionId: "",
      });
    } catch (error) {
      console.error("API Error:", error);
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={approvedPopupOpen}
      onClose={handleCloseApproved}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <img
              src={withdrawalItem?.userId?.selected_Avatar}
              alt="Avatar"
              className="mr-2 h-14 w-14 rounded-full"
            />
            <h2 className="text-xl font-semibold tracking-wide">
              {withdrawalItem?.userId?.fullName}
            </h2>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-4">
              <div className="flex space-x-4">
                <div className="flex-1">
                  <label
                    htmlFor="requestedAmount"
                    className="mb-2 block text-lg tracking-wide"
                  >
                    Requested Amount
                  </label>
                  <input
                    type="text"
                    id="requestedAmount"
                    name="requestedAmount"
                    value={withdrawalItem?.requestedAmount}
                    disabled
                    className="w-full rounded-md border p-2"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="status"
                    className="mb-2 block text-lg tracking-wide"
                  >
                    Status
                  </label>
                  <input
                    type="text"
                    id="status"
                    name="status"
                    value="Approved"
                    disabled
                    className="w-full rounded-md border p-2 font-mono tracking-wide text-green-500"
                    required
                  />
                </div>
              </div>

              <div className="flex space-x-4">
                <div className="flex-1">
                  <label
                    htmlFor="tds"
                    className="mb-2 block text-lg tracking-wide"
                  >
                    TDS (in %)
                  </label>
                  <input
                    type="number"
                    id="tds"
                    name="tds"
                    value={formData.tds}
                    onChange={handleTdsChange}
                    className="w-full rounded-md border p-2"
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="disbursedAmount"
                    className="mb-2 block text-lg tracking-wide"
                  >
                    Disbursed Amount
                  </label>
                  <input
                    type="text"
                    id="disbursedAmount"
                    name="disbursedAmount"
                    value={formData?.disbursedAmount?.toFixed(2)}
                    disabled
                    className="w-full rounded-md border p-2"
                    required
                  />
                </div>
              </div>

              <div className="flex space-x-4">
                <div className="flex-1">
                  <label
                    htmlFor="transactionId"
                    className="mb-2 block text-lg tracking-wide"
                  >
                    Transaction ID (UTR)
                  </label>
                  <input
                    type="text"
                    id="transactionId"
                    name="transactionId"
                    value={formData.transactionId}
                    onChange={handleChange}
                    className="w-full rounded-md border p-2"
                    required
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-4 tracking-wide">
                <button
                  className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
                  onClick={handleCloseApproved}
                >
                  Cancel
                </button>
                {isLoading ? (
                  <button
                    className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white"
                    disabled
                  >
                    <BtnLoader />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="rounded-md bg-[#c51369] p-3 font-medium text-white transition duration-200 hover:bg-[#a10f5b]"
                  >
                    {warningMsg}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </Box>
    </Modal>
  );
};

export default WithdrawalApprovedPopup;
